import React from 'react';
import { Chip, CircularProgress, Typography } from '@mui/material';
import SectionShell from './SectionShell';

/** A section whose data key hasn't been written yet, while the session is
 *  still `pending`, is "not computed yet", not "not applicable". Silently
 *  omitting it would look identical to the not-applicable case. */
const ProcessingSection: React.FC<{ title: string }> = ({ title }) => (
  <SectionShell
    title={title}
    headline={(
      <Chip
        icon={<CircularProgress size={14} sx={{ ml: 0.5 }} />}
        label="Processing…"
        variant="outlined"
      />
    )}
  >
    <Typography variant="caption" color="text.secondary">
      This section is still being analysed. Refresh in a moment.
    </Typography>
  </SectionShell>
);

export default ProcessingSection;
